import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'SyncITFilterPipe'
})
export class SyncITFilterPipe implements PipeTransform {

  transform(items: any[], billToName: string, shipToName: string, clientAdminEmail: string): any[] {
    if (!items || items.length === 0) {
      return [];
    }

    return items.filter(item => {
      let matchBillTo = true;
      let matchShipTo = true;
      let matchClientAdmin = true;

      if (billToName && billToName.trim() !== '') {
        matchBillTo = item.BillToName && item.BillToName.toLowerCase().indexOf(billToName.toLowerCase()) !== -1;
      }

      if (shipToName && shipToName.trim() !== '') {
        matchShipTo = item.ShipToName && item.ShipToName.toLowerCase().indexOf(shipToName.toLowerCase()) !== -1;
      }

      if (clientAdminEmail && clientAdminEmail.trim() !== '') {
        matchClientAdmin = item.ClientAdminEmail && item.ClientAdminEmail.toLowerCase().indexOf(clientAdminEmail.toLowerCase()) !== -1;
      }

      return matchBillTo && matchShipTo && matchClientAdmin;
    });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/syncit/pipes/SyncITFilterPipe.ts